"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const colorGray = "#3c4043";
const colorLink = "#1155cd";
exports.styles = {
    document: {
        padding: "0 0.5cm",
        fontFamily: "Arial, Helvetica, sans-serif",
        fontSize: "14px",
        lineHeight: "1.3",
    },
    link: {
        color: colorLink,
    },
    documentHeader: {
        color: colorGray,
    },
    centerSubHeader: {
        textAlign: "center",
    },
    table: {
        float: "left",
        width: "100%",
        borderCollapse: "collapse",
        margin: "0.6cm 0",
    },
    tableLeftTd: {
        border: "1px solid",
        padding: "0.2cm",
    },
    tableRightTd: {
        border: "1px solid",
        color: colorGray,
        padding: "0.2cm",
    },
    paragraph: {
        textAlign: "justify",
    },
    paragraphBold: {
        fontWeight: "bold",
        textAlign: "justify",
    },
    paragraphMarginTop0: {
        textAlign: "justify",
        marginTop: 0,
    },
    paragraphMargin0: {
        textAlign: "justify",
        marginTop: 0,
        marginBottom: 0,
    },
    paragraphMarginBottom0: {
        textAlign: "justify",
        marginBottom: 0,
    },
    h3Margin0: {
        marginBottom: "0.4em",
        fontSize: "1em",
        lineHeight: "1.4em",
        fontWeight: "bold",
    },
    lightGray: {
        color: "#3c4043",
    },
    iconsArea: {
        padding: "10px",
        textAlign: "center",
    },
    paragraphMargin0Center: {
        textAlign: "center",
        marginTop: 0,
        marginBottom: 0,
    },
    list: {
        marginTop: 0,
        listStyle: "upper-alpha",
    },
    signatureArea: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px",
    },
    signaturePartner: {
        display: "flex",
        flexDirection: "column",
    },
    signatureDaytrip: {
        display: "flex",
        flexDirection: "column",
    },
    paragraphTitle: {
        display: "flex",
        justifyContent: "start",
        fontWeight: 500,
    },
    paragraphBoldCentered: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        fontWeight: "bold",
    },
    centredList: {
        listStyleType: "circle",
        paddingLeft: "120px",
    },
    pageBreak: {
        pageBreakBefore: "always",
    },
    docTable: {
        fontSize: "10px",
        borderCollapse: "collapse",
    },
    docCell: {
        border: "1px solid",
        padding: "8px",
    },
};
//# sourceMappingURL=CooperationAgreementDynamicFormDocumentStyles.js.map